import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { request } from "@/js/http/http_request";
import { hasRole } from "@/js/http/auth.js";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { casingWines, stockReservationTypes, wineStockStatus } from "@/js/lists.ts";
import { getFullNameUser } from "@/js/user/user.js";
import { getCurrentOrder, getThirdPartyUserSelected } from "@/js/order/order.js";
import WineNaming from "@/components/products/WineNaming.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
import StockActionButton from "@/components/products/WineStockListModalStockActionButton.vue";
export default {
  name: "WineStockListModal",
  components: {
    "wine-naming": WineNaming,
    ErrorModal: ErrorModal,
    StockActionButton: StockActionButton
  },
  props: {
    wine: {
      type: Object
    },
    quantity: {
      type: Number,
      default: 1
    },
    casingId: {
      type: String,
      default: ""
    },
    order: {
      type: Object
    },
    quantityIsFixed: {
      type: Boolean,
      default: false
    },
    isBasket: {
      type: Boolean,
      default: false
    },
    isUsedStockSwitchable: {
      type: Boolean,
      default: false
    },
    expedition_methods: {
      type: Array
    },
    add: Function
  },
  data: function data() {
    return {
      shown: false,
      options: {
        color: "primary",
        zIndex: 2000
      },
      canAdminBypassStock: false,
      isLoading: false,
      items: [],
      headers: [{
        text: "",
        value: "firstAction",
        align: "left"
      }, {
        text: "Type",
        value: "type",
        align: "center"
      }, {
        text: "Available",
        value: "stock_quantity",
        align: "center"
      }, {
        text: "Storage continent",
        value: "storage_continent",
        align: "center"
      }, {
        text: "Warehouse",
        value: "warehouse.name",
        align: "center"
      }, {
        text: "Ref. warehouse",
        value: "reference_warehouse",
        align: "center"
      }, {
        text: "Intended countries",
        value: "intented_countries",
        align: "center",
        width: "250px"
      }, {
        text: "Reservation",
        value: "reservation",
        align: "center"
      }, {
        text: "Case",
        value: "case",
        align: "center",
        width: "100px"
      }, {
        text: "Casing",
        value: "casingId",
        align: "center",
        width: "100px"
      }, {
        text: "Warning",
        value: "warning",
        align: "center"
      }, {
        text: "",
        value: "action",
        align: "right"
      }],
      orderEdited: {},
      availableDepartures: [],
      completeTargetUser: null,
      orderDepartureWarehouse: null,
      casingWines: casingWines,
      wineStockStatus: wineStockStatus,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isChangingUsedStock: function isChangingUsedStock() {
      var _this$orderEdited,
        _this2 = this;
      return (_this$orderEdited = this.orderEdited) === null || _this$orderEdited === void 0 || (_this$orderEdited = _this$orderEdited.items) === null || _this$orderEdited === void 0 ? void 0 : _this$orderEdited.some(function (item) {
        return item.id_wine === _this2.wine.id_wine;
      });
    },
    casingsAvailable: function casingsAvailable() {
      return this.wine.casings;
    }
  },
  created: function created() {
    var _this3 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this3.canAdminBypassStock = hasRole(process.env.VUE_APP_ROLES_BYPASS_STOCK_RESERVATION);
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    resetData: function resetData() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this4$orderEdited, _this4$orderEdited2, _this4$expedition_met, _this4$wine$stocks, casing, bottleQuantity, departureContinent, _this4$expedition_met2;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this4.isLoading = true;
              _this4.items = [];
              _this4.orderEdited = _this4.isBasket ? getCurrentOrder() : _this4.order;
              if (!_this4.wine) {
                _context2.next = 20;
                break;
              }
              casing = _this4.casingId.match(/\d+/)[0];
              bottleQuantity = _this4.quantity * casing;
              departureContinent = (_this4$orderEdited = _this4.orderEdited) !== null && _this4$orderEdited !== void 0 && _this4$orderEdited.id_warehouse ? (_this4$orderEdited2 = _this4.orderEdited) === null || _this4$orderEdited2 === void 0 || (_this4$orderEdited2 = _this4$orderEdited2.expedition_methods[_this4.orderEdited.id_warehouse]) === null || _this4$orderEdited2 === void 0 ? void 0 : _this4$orderEdited2.departureContinent : null;
              if (!departureContinent && ((_this4$expedition_met = _this4.expedition_methods) === null || _this4$expedition_met === void 0 ? void 0 : _this4$expedition_met.length) > 0) {
                departureContinent = (_this4$expedition_met2 = _this4.expedition_methods[0]) === null || _this4$expedition_met2 === void 0 ? void 0 : _this4$expedition_met2.departureContinent;
              }
              (_this4$wine$stocks = _this4.wine.stocks) === null || _this4$wine$stocks === void 0 || _this4$wine$stocks.forEach(function (stock) {
                var _item$storage_contine;
                var item = _objectSpread(_objectSpread({}, stock), {}, {
                  casingId: _this4.casingId,
                  case: bottleQuantity > stock.stock_quantity && !(_this4.isChangingUsedStock && _this4.wine.id_stock == stock.id_stock) ? Math.floor(stock.stock_quantity / casing) : _this4.quantity,
                  initial_case: bottleQuantity > stock.stock_quantity && !(_this4.isChangingUsedStock && _this4.wine.id_stock == stock.id_stock) ? Math.floor(stock.stock_quantity / casing) : _this4.quantity,
                  intented_countries: stock.stock_countries.length === stock.total_implanted_countries || stock.stock_countries.length === 0 ? "All" : stock.stock_countries.map(function (x) {
                    return x.printable_name;
                  }).join(", "),
                  max_quantity_case: Math.floor(stock.stock_quantity / casing)
                });
                if (stock.stock_type.toLowerCase() === "stock") {
                  var _stock$warehouse;
                  item.type = "Stock";
                  item.storage_continent = (_stock$warehouse = stock.warehouse) === null || _stock$warehouse === void 0 || (_stock$warehouse = _stock$warehouse.address) === null || _stock$warehouse === void 0 || (_stock$warehouse = _stock$warehouse.country) === null || _stock$warehouse === void 0 ? void 0 : _stock$warehouse.continent_iso_2;
                } else if (stock.stock_type.toLowerCase() === "consignment") {
                  var _stock$consignment_st;
                  item.type = "Direct Producer";
                  item.storage_continent = (_stock$consignment_st = stock.consignment_storage) === null || _stock$consignment_st === void 0 || (_stock$consignment_st = _stock$consignment_st.country) === null || _stock$consignment_st === void 0 ? void 0 : _stock$consignment_st.continent_iso_2;
                }
                (_item$storage_contine = item.storage_continent) !== null && _item$storage_contine !== void 0 ? _item$storage_contine : item.storage_continent = item.stock_storage_continent_iso2;
                if (stock.stock_reservation_type === stockReservationTypes.SPECIFIC_CUSTOMER.id) {
                  item.reservation = getFullNameUser(stock.stock_reservation_user);
                } else if (stock.stock_reservation_type === stockReservationTypes.SPECIFIC_CONSULTANT.id) {
                  item.reservation = getFullNameUser(stock.stock_reservation_consultant);
                } else if (stock.stock_reservation_type) {
                  item.reservation = Object.values(stockReservationTypes).find(function (x) {
                    return x.id === stock.stock_reservation_type;
                  }).shortListLabel;
                }
                if (_this4.orderEdited) {
                  var _this4$orderEdited$co;
                  if (_this4.wine.id_stock === item.id_stock) {
                    item.status = wineStockStatus.DEFAULT;
                  } else if ((_this4.isBasket || item.storage_continent === departureContinent) && (item.stock_countries.length === 0 || item.stock_countries.some(function (x) {
                    return x.id_country === _this4.orderEdited.delivery_address.country.id_country;
                  })) && (item.stock_reservation_type === stockReservationTypes.DEFAULT.id || item.stock_reservation_type === stockReservationTypes.SPECIFIC_CUSTOMER.id && item.stock_reservation_user_id === _this4.orderEdited.user.id_user || item.stock_reservation_type === stockReservationTypes.SPECIFIC_CONSULTANT.id && (item.stock_reservation_consultant_id === _this4.orderEdited.user.id_user || item.stock_reservation_consultant_id === ((_this4$orderEdited$co = _this4.orderEdited.consultant) === null || _this4$orderEdited$co === void 0 ? void 0 : _this4$orderEdited$co.id_user)) || item.stock_reservation_type === stockReservationTypes.GROUP_HORECA_WHOLESALER.id && (_this4.orderEdited.user.user_group === "HORECA" || _this4.orderEdited.user.user_group === "WHOLESALER" || _this4.orderEdited.user.isHolding) || item.stock_reservation_type === stockReservationTypes.GROUP_USER.id && _this4.orderEdited.user.user_group === "USER")) {
                    item.status = wineStockStatus.AVAILABLE;
                  } else {
                    item.status = wineStockStatus.UNAVAILABLE;
                  }
                }
                if (item.status === wineStockStatus.DEFAULT) {
                  item.statusLabel = "success";
                } else if (item.status === wineStockStatus.AVAILABLE) {
                  item.statusLabel = "warning";
                } else {
                  item.statusLabel = "danger";
                }
                _this4.items.push(item);
              });
              _context2.next = 11;
              return _this4.getCompleteTargetUser();
            case 11:
              if (_this4.isBasket) {
                _context2.next = 16;
                break;
              }
              _context2.next = 14;
              return _this4.getOrderDepartureWarehouse();
            case 14:
              _context2.next = 18;
              break;
            case 16:
              _context2.next = 18;
              return _this4.getAvailableDepartureWarehouse();
            case 18:
              _this4.items.map(function (stock) {
                stock = _this4.setBypassStockWarningMessages(stock);
              });
              _this4.items.sort(function (a, b) {
                return a.status - b.status;
              });
            case 20:
              _this4.isLoading = false;
            case 21:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    addProduct: function addProduct(item) {
      if (item.case > 0) {
        var result = _objectSpread(_objectSpread({}, this.wine), {}, {
          id_stock: item.id_stock
        });
        this.shown = false;
        return this.add(result, item.casingId, true, item.case);
      }
    },
    getCompleteTargetUser: function getCompleteTargetUser() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _getThirdPartyUserSel;
        var userId, _this, resp;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              userId = _this5.isBasket ? (_getThirdPartyUserSel = getThirdPartyUserSelected()) === null || _getThirdPartyUserSel === void 0 ? void 0 : _getThirdPartyUserSel.id_user : _this5.order.id_user;
              _this = _this5;
              _context3.next = 4;
              return request("/v1/user/" + userId, "get", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load the target user.");
                handleErrorData(_this, errorData);
              });
            case 4:
              resp = _context3.sent;
              _this5.completeTargetUser = resp.data;
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getOrderDepartureWarehouse: function getOrderDepartureWarehouse() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this, resp;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this = _this6;
              _context4.next = 3;
              return request("/v1/warehouse/" + _this6.order.id_warehouse, "get", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load the departure warehouse.");
                handleErrorData(_this, errorData);
              });
            case 3:
              resp = _context4.sent;
              _this6.orderDepartureWarehouse = _objectSpread({}, resp.data);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    getAvailableDepartureWarehouse: function getAvailableDepartureWarehouse() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _getThirdPartyUserSel2;
        var idUserTarget;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this7.availableDepartures = [];
              idUserTarget = (_getThirdPartyUserSel2 = getThirdPartyUserSelected()) === null || _getThirdPartyUserSel2 === void 0 ? void 0 : _getThirdPartyUserSel2.id_user;
              _context5.next = 4;
              return request("/v1/warehouses/available-departures/".concat(idUserTarget), "get", null, true, "api", null);
            case 4:
              _this7.availableDepartures = _context5.sent.data.value;
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    setBypassStockWarningMessages: function setBypassStockWarningMessages(stock) {
      var customer = this.completeTargetUser;
      var hasBeenModified = false;
      stock.warningReasons = [];
      if (this.isBasket) {
        var deliveryContinentIso2 = customer.delivery_address.country.continent_iso_2;
        if (deliveryContinentIso2 === "EU") {
          var isIncompatibleContinent = stock.storage_continent !== "EU";
          if (isIncompatibleContinent) {
            stock.warningReasons.push("Storage continent (".concat(stock.storage_continent, ") not compatible with the continent of delivery (").concat(deliveryContinentIso2, ")."));
            hasBeenModified = true;
            stock.isIncompatibleContinent = true;
          }
        }
        if (this.availableDepartures && !this.availableDepartures.some(function (x) {
          return x.warehouseId == stock.warehouse_default_departure.id_warehouse;
        })) {
          stock.warningReasons.push("Storage departure (".concat(stock.warehouse_default_departure.name, ") not compatible with the delivery address."));
          hasBeenModified = true;
        }
      } else {
        var departureContinentIso2 = this.orderDepartureWarehouse.address.country.continent_iso_2;
        var _isIncompatibleContinent = stock.storage_continent !== departureContinentIso2;
        if (_isIncompatibleContinent) {
          stock.warningReasons.push("Storage continent (".concat(stock.storage_continent, ") not compatible with the continent of warehouse departure (").concat(departureContinentIso2, ")."));
          hasBeenModified = true;
          stock.isIncompatibleContinent = true;
        }
      }
      var isCountryAvailable = stock.stock_countries.find(function (x) {
        return x.iso_2 === customer.delivery_address.country.iso_2;
      });
      if (!isCountryAvailable) {
        stock.warningReasons.push("This stock is not intended for country of delivery (".concat(customer.delivery_address.country.country_label, ")."));
        hasBeenModified = true;
      }
      var isStockReservedForUser = stock.stock_reservation_type === stockReservationTypes.DEFAULT.id || stock.stock_reservation_type === stockReservationTypes.SPECIFIC_CUSTOMER.id && stock.stock_reservation_user_id === customer.id_user || stock.stock_reservation_type === stockReservationTypes.SPECIFIC_CONSULTANT.id && (stock.stock_reservation_consultant_id === customer.consultantAttachedId || stock.stock_reservation_consultant_id === customer.id_user) || stock.stock_reservation_type === stockReservationTypes.GROUP_HORECA_WHOLESALER.id && (customer.user_group === "HORECA" || customer.user_group === "WHOLESALER" || customer.isHolding) || stock.stock_reservation_type === stockReservationTypes.GROUP_USER.id && customer.user_group === "USER";
      if (!isStockReservedForUser) {
        if (stock.stock_reservation_type === stockReservationTypes.SPECIFIC_CUSTOMER.id) {
          stock.warningReasons.push("This stock is not reserved for ".concat(getFullNameUser(customer), "."));
        } else if (stock.stock_reservation_type === stockReservationTypes.SPECIFIC_CONSULTANT.id) {
          var userToShow = customer.consultantAttachedId > 0 ? customer.consultantAttached : customer;
          stock.warningReasons.push("This stock is not reserved for ".concat(getFullNameUser(userToShow), "."));
        } else {
          stock.warningReasons.push("This stock is only reserved to the following group : ".concat(stock.reservation, "."));
        }
        hasBeenModified = true;
      }
      var notEnoughQty = stock.stock_quantity < Number(stock.casingId.match(/\d+/)[0]);
      if (notEnoughQty) {
        stock.warningReasons.push("The available stock quantity is not sufficient to fulfill a case.");
        hasBeenModified = true;
      }
      if (hasBeenModified) {
        if (notEnoughQty) {
          stock.statusLabel = "danger";
          stock.status = wineStockStatus.UNAVAILABLE;
        } else {
          stock.statusLabel = "warning";
        }
      }
      stock.canBeBypassStockReservation = hasBeenModified;
      return stock;
    },
    updateInitialQuantity: function updateInitialQuantity(stock) {
      var casing = stock.casingId.match(/\d+/)[0];
      if (stock.case == 0 && casing <= stock.stock_quantity) {
        stock.case = 1;
      }
      var bottleQuantity = stock.case * casing;
      stock.max_quantity_case = Math.floor(stock.stock_quantity / casing);
      stock.initial_case = bottleQuantity > 0 && bottleQuantity > stock.stock_quantity ? stock.max_quantity_case : stock.case;
      stock = this.setBypassStockWarningMessages(stock);
    },
    isAddToCartDisabled: function isAddToCartDisabled(stock) {
      if (stock.isIncompatibleContinent === true) return true;
      if (this.canAdminBypassStock === true) {
        return stock.stock_quantity < 1;
      } else {
        return stock.stock_quantity < 1 || stock.status === wineStockStatus.UNAVAILABLE || stock.canBeBypassStockReservation;
      }
    },
    open: function open() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this8.shown = true;
              _context6.next = 3;
              return _this8.resetData();
            case 3:
              return _context6.abrupt("return", new Promise(function (resolve, reject) {
                _this8.resolve = resolve;
                _this8.reject = reject;
              }));
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    cancel: function cancel() {
      this.shown = false;
      this.$emit("closed");
    }
  }
};